<template>
  <div class="content-box">
    <main class="content-main">
      <a @click="openUrl" style="cursor: pointer;">
        <img style="width: 1248px;height: 450px" src="@/assets/image/en/EnBanner.jpg" alt="">
      </a>
      <!-- <img style="width: 1248px;height: 450px" src="@/assets/image/en/infobanner.jpg" alt=""> -->
      <!-- Headlines -->
      <!-- <el-carousel height="230px" :interval="3000">
        <el-carousel-item  v-for="(item, index) in list_img" :key="index">
          <h3 class="png">
            <a :href="item.Url" target="_blank">
              <img :src="getUrl(item.PhotoAddr)" style="height: 230px;"/>
            </a>
          </h3>
        </el-carousel-item>
      </el-carousel> -->
      <!--
      <section class="section-card-box">
        <section-title title="Selected"/>
        <div class="card-box">
          <section-card-headlines v-for="item in headlinesList" :key="item.NewsID" :data="item" :is-en-expire="isInfoEnExpire"/>
        </div>
      </section>
      -->
      <!-- BTC Express -->
      <section class="section-card-box">
        <section-title title="BTC Express"/>
        <div class="card-box">
          <section-card v-for="item in expressList" :key="item.NewsID" :data="item" :is-en-expire="isInfoEnExpire"/>
        </div>
        <div class="more hand" @click="handleShowMore(1, '_exoress_en')">Show More</div>
      </section>
      <!-- BTC Analysys -->
      <section class="section-card-box">
        <section-title title="BTC Analysis"/>
        <div class="card-box">
          <section-card v-for="item in analysysList" :key="item.NewsID" :data="item" :is-en-expire="isInfoEnExpire"/>
        </div>
        <div class="more hand" @click="handleShowMore(1, '_analysis_en')">Show More</div>
      </section>
      <!-- BTC Report -->
      <section class="section-card-box">
        <section-title-index title="BTC Report" @change-language="handleChangeLanguage"/>
        <div class="report-box">
          <!--<div class="week-more hand" @click="handleTapPrev">
            <img src="@/assets/image/price/analysis/more.png" class="trans">
          </div>
          -->
          <!--<transition-group :name="transOrientation" class="card-item-box">-->
            <report-card v-for="item in reportList" :key="item.BulletinID" :data="item" :is-en-expire="isReportEnExpire" :lang="reportQuery.Lang" style="min-width: 353px; margin-left: 10px;"/>
          <!--</transition-group>-->
          <!--
          <div class="week-more hand" @click="handleTapNext">
            <img src="@/assets/image/price/analysis/more.png">
          </div>
          -->
        </div>
        <div class="more hand" @click="handleShowMore(2)">Show More</div>
      </section>
    </main>
  </div>
</template>

<script>
import commonmix from '@/utils/commonmix'
import ReportCard from './components/report-card'
import SectionCard from './components/section-card'
// import SectionCardHeadlines from './components/section-card-headlines'
import SectionTitle from './components/section-title'
import SectionTitleIndex from './components/section-title-index'

export default {
  mixins: [commonmix],
  name: 'BTCInfo',
  components: {
    SectionCard,
    SectionTitle,
    // SectionCardHeadlines,
    ReportCard,
    SectionTitleIndex
  },
  data () {
    return {
      headlinesList: [],
      headlinesQuery: {
        NewsLanguageCode: 'en'
      },
      listQuery: {
        PageNum: 1,
        PageSize: 4,
        NewsLanguageCode: 'en'
      },
      expressList: [],
      analysysList: [],
      reportTotal: 0,
      reportList: [],
      reportQuery: {
        PageNum: 1,
        PageSize: 9,
        Lang: 1
      },
      transOrientation: '',
      titleTxt: 'BTC Report'
    }
  },
  computed: {
    totalPage () {
      return Math.ceil(this.reportTotal / this.reportQuery.PageSize)
    },
    isInfoEnExpire () {
      return this.getUserProfile(this.$t('message._beefnewsandevents_en'))
    },
    isReportEnExpire () {
      return this.getUserProfile(this.$t('message._beefreports_en'))
    }
  },
  mounted () {
    this.getHeadLine()
    this.getNewsList('_exoress_en', 'expressList')
    this.getNewsList('_analysis_en', 'analysysList')
    this.getReport()
  },
  methods: {
    openUrl () {
      window.open('https://www.beeftochina.com.cn', '_blank')
    },
    getHeadLine () {
      this.$store.dispatch('SetLoadingStatus', true)
      this.$store.dispatch('GetBtcInfoHeadlines', this.headlinesQuery)
        .then(() => {
          this.headlinesList = this.$store.getters.newsRows
          this.$store.dispatch('SetLoadingStatus', false)
        }).catch((err) => {
          this.$store.dispatch('SetLoadingStatus', false)
          console.log(err)
        })
    },
    getNewsList (type, list) {
      this.listQuery.Type = type
      this.$store.dispatch('SetLoadingStatus', true)
      this.$store.dispatch('GetBtcInfoNewsBySection', this.listQuery)
        .then(() => {
          this.$store.dispatch('SetLoadingStatus', false)
          this[list] = this.$store.getters.newsRows
        }).catch((err) => {
          this.$store.dispatch('SetLoadingStatus', false)
          console.log(err)
        })
    },
    getReport () {
      this.$store.dispatch('SetLoadingStatus', true)
      this.$store.dispatch('GetBeefInfoReport', this.reportQuery)
        .then(() => {
          this.reportList = this.$store.getters.newsRows
          this.reportTotal = this.$store.getters.newsTotal
          this.$store.dispatch('SetLoadingStatus', false)
        }).catch((err) => {
          this.$store.dispatch('SetLoadingStatus', false)
          console.log(err)
        })
    },
    handleClickNews (e) {
      if (this.$store.getters.token) {
        this.$store.commit('SET_NEWSID', e)
        // this.$router.push(`/BTCInfo/Article/${e}`)
        const path = `/BTCInfo/ArticleFree/${e}`
        const routeData = this.$router.resolve({ path: path })
        const open = window.open(routeData.href, '_blank')
        if (open === null || typeof (open) === 'undefined') {
          this.$router.push(path)
        }
      } else {
        this.openLoginModal()
      }
      // sessionStorage.setItem('recommendation', e)
      // const path = `/BTCInfo/Article/${e}`
      // const routeData = this.$router.resolve({ path: path })
      // const open = window.open(routeData.href, '_blank')
      // if (open === null || typeof (open) === 'undefined') {
      //   this.$router.push(path)
      // }
    },
    handleShowMore (type, section) {
      if (type === 1) {
        this.$router.push({ path: '/BTCInfo/Section', query: { type: section } })
      }
      if (type === 2) {
        this.$router.push('/BTCInfo/Report')
      }
    },
    handleTapPrev () {
      this.transOrientation = 'left'
      if (this.reportQuery.PageNum > 1) {
        this.reportQuery.PageNum -= 1
      }
      this.getReport()
    },
    handleTapNext () {
      this.transOrientation = 'right'
      if (this.reportQuery.PageNum < this.totalPage) {
        this.reportQuery.PageNum += 1
      }
      this.getReport()
    },
    handleChangeLanguage (lang) {
      if (lang === 1) {
        this.titleTxt = 'BTC Report'
      }
      if (lang === 2) {
        this.titleTxt = 'Reporte de BTC'
      }
      if (lang === 3) {
        this.titleTxt = 'Relatório de BTC'
      }
      this.reportQuery.PageNum = 1
      this.reportQuery.Lang = lang
      this.getReport()
    }
  }
}
</script>

<style scoped>
.content-box {
  display: flex;
  justify-content: center;
  background-color: #f5f5f5;
}
.content-main {
  width: 1248px;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.content-main > .section-card-box {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.card-box {
  display: flex;
}

.more {
  height: 30px;
  line-height: 30px;
  border-radius: 15px;
  padding: 0 40px;
  font-size: 12px;
  display: inline-block;
  border: 1px solid #e0e0e0;
  margin: 10px 0;
  margin-top: 20px;
}

.report-box{
  display: inline-block;
  width: 1200px;
  justify-content: center;
  align-items: center;
}

.report-box > div{
  margin: 20px;
}

.week-more{
  width: 30px;
  height: 106px;
  border-radius: 8px;
  background-color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 5px 2px #e0e0e0;
}

.week-more > img{
  width: 6px;
  height: 13px;
}

.trans{
  transform:rotate(180deg);
}

.card-item-box {
  width: 1100px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  overflow-x: hidden;
}

.left-enter-active,
.left-leave-active {
  transition: all 0.2s ease;
}
.left-enter-from,
.left-leave-to {
  opacity: 0;
  transform: translateX(-30px);
}

.right-enter-active,
.right-leave-active {
  transition: all 0.2s ease;
}
.right-enter-from,
.right-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

</style>
